import { Input, Button, FormControl, FormLabel, InputGroup, Text } from '@chakra-ui/react';
import React from 'react';

const FileUploader = ({ onFileChange, buttonText, label, placeholder, helperText, documentType }) => {
    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        const maxFiles = documentType === 'company_doc' ? 3 : 1;
        
        // Validate file types
        const validFiles = files.filter(file => {
            const fileType = file.type.toLowerCase();
            return fileType === 'application/pdf' || fileType.startsWith('image/');
        });

        if (validFiles.length !== files.length) {
            alert('Only PDF and image files are allowed');
            e.target.value = ''; // Clear the input
            return;
        }

        // Check if adding new files would exceed the limit
        if (validFiles.length > maxFiles) {
            alert(`You can only upload a maximum of ${maxFiles} ${documentType === 'company_doc' ? 'company documents' : 'document'}`);
            e.target.value = ''; // Clear the input
            return;
        }

        onFileChange(validFiles, documentType);
    };

    const updateFileDisplay = (files) => {
        const fileInput = document.getElementById(`file-display-${documentType}`);
        if (fileInput) {
            fileInput.value = files.length ? files.map(file => file.name).join(', ') : '';
        }
    };

    // Add effect to update display when files change externally
    React.useEffect(() => {
        // Listen for custom event
        const handleFileUpdate = (e) => {
            if (e.detail.documentType === documentType) {
                updateFileDisplay(e.detail.files);
            }
        };

        window.addEventListener('fileListUpdated', handleFileUpdate);
        return () => window.removeEventListener('fileListUpdated', handleFileUpdate);
    }, [documentType]);

    return (
        <FormControl my="4">
            <FormLabel htmlFor={`file-upload-${documentType}`} mb="0" color="#4E4E4E" fontSize="14px"
                fontWeight="500">{label}</FormLabel>
            <InputGroup my=".5rem">
                <Button
                    as="label"
                    htmlFor={`file-upload-${documentType}`}
                    colorScheme="gray"
                    cursor="pointer"
                    _hover={{ bg: 'transparent' }}
                    bg="#F5F6FA"
                    height="48px"
                    borderRadius="6px 0 0 6px"
                    color="#929090"
                    border="1px solid #D1D1D1"
                    fontSize="14px"
                    fontWeight="400"
                    p="1.5rem"
                    width='auto'
                    textAlign='center'
                >
                    {buttonText}
                    <input
                        type="file"
                        id={`file-upload-${documentType}`}
                        multiple
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                        accept="application/pdf,image/*"
                    />
                </Button>
                <Input
                    id={`file-display-${documentType}`}
                    readOnly
                    bg="white"
                    border="1px solid #D1D1D1"
                    height="48px"
                    borderRadius="0 6px 6px 0"
                    placeholder={placeholder}
                />
            </InputGroup>
            <Text color="#999999" fontSize="12px"
                fontWeight="400">{helperText}</Text>
        </FormControl>
    );
};

export default FileUploader;